import { Routes, Route, Navigate } from "react-router-dom";

import { CollaboratorsLayout } from "@/features/Collaborators/Layout";
import {
  CollaboratorsStatusManagementPage,
  CollaboratorsDirectoryPage,
} from "@/features/Collaborators/List";
import { CollaboratorEditPage } from "@/features/Collaborators/Edit/Pages";
import { CollaboratorIndicatorsPage } from "@/features/Collaborators/Indicators";
import { CollaboratorAllocationsPage } from "@/features/Collaborators/pages/CollaboratorAllocationsPage";
import { CollaboratorAllocationFormPage } from "@/features/Collaborators/pages/CollaboratorAllocationFormPage";
import { CollaboratorAllocationsOverviewPage } from "@/features/Collaborators/pages/CollaboratorAllocationsOverviewPage";
import {
  CollaboratorAvailabilitiesPage,
  CollaboratorAvailabilityFormPage,
} from "@/features/Collaborators/Availabilities/pages";
import { EvaluationWizardPage } from "@/features/Collaborators/PerformanceEvaluation/pages/EvaluationWizardPage";
import { CollaboratorEvaluationsDashboardPage } from "@/features/Collaborators/PerformanceEvaluation/pages/CollaboratorEvaluationsDashboardPage";
import { CollaboratorProfilePage } from "@/features/Collaborators/pages/CollaboratorProfilePage";
import { CollaboratorExpensesPage } from "@/features/Collaborators/pages/CollaboratorExpensesPage";
import { CollaboratorContractPage } from "@/features/Collaborators/pages/CollaboratorContractPage";
import { ROLE_COMBINATIONS } from "@/router/proxyRouter.definitions";
import { CollaboratorBasicInfoPage } from "@/features/Collaborators/pages/CollaboratorBasicInfoPage";
import { CollaboratorSalaryPage } from "@/features/Collaborators/pages/CollaboratorSalaryPage";
import { RoleBasedRoute } from "..";

export default function CollaboratorsRoutes() {
  return (
    <Routes>
      {/* Diretório de colaboradores - acessível a usuários logados (sem roles específicos) */}
      <Route
        path="/directory"
        element={
          <RoleBasedRoute requiredRoles={[]}>
            <CollaboratorsLayout />
          </RoleBasedRoute>
        }
      >
        <Route index element={<CollaboratorsDirectoryPage />} />
      </Route>

      {/* Performance Evaluations - Accessible to all logged-in users */}
      <Route
        path="/evaluations"
        element={
          <RoleBasedRoute requiredRoles={[]}>
            <CollaboratorsLayout />
          </RoleBasedRoute>
        }
      >
        <Route index element={<CollaboratorEvaluationsDashboardPage />} />
        <Route path=":id" element={<EvaluationWizardPage />} />
      </Route>

      {/* Registro (alias para directory) */}
      <Route
        path="/registry"
        element={<Navigate to="/collaborators/directory" replace />}
      />

      {/* Rotas de Gerenciamento (Updates, Indicators, etc.) - Restritas */}
      <Route
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_ACCESS}>
            <CollaboratorsLayout />
          </RoleBasedRoute>
        }
      >
        <Route path="updates" element={<CollaboratorsStatusManagementPage />} />
        <Route path="indicators" element={<CollaboratorIndicatorsPage />} />
        <Route path="allocations" element={<CollaboratorAllocationsOverviewPage />} />
        <Route path="availabilities" element={<CollaboratorAvailabilitiesPage />} />



        <Route
          path="allocations/new"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorAllocationFormPage />
            </RoleBasedRoute>
          }
        />

        <Route
          path="availabilities/form"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorAvailabilityFormPage />
            </RoleBasedRoute>
          }
        />
      </Route>

      {/* Rotas de Perfil (:id) - Acesso Público (Visualização) + Sub-rotas Protegidas */}
      <Route
        path=":id"
        element={
          <RoleBasedRoute requiredRoles={[]}>
            <CollaboratorsLayout />
          </RoleBasedRoute>
        }
      >
        <Route index element={<CollaboratorProfilePage />} />

        <Route
          path="basic-info"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorBasicInfoPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="expenses"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorExpensesPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="contract"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorContractPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="salary"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorSalaryPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="edit"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_EDIT_PAGE}>
              <CollaboratorEditPage />
            </RoleBasedRoute>
          }
        />

        {/* Alocações do Colaborador */}
        <Route
          path="allocations"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_ACCESS}>
              <CollaboratorAllocationsPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="allocations/new"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorAllocationFormPage />
            </RoleBasedRoute>
          }
        />
        <Route
          path="allocations/:allocationId/edit"
          element={
            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.COLLABORATOR_MANAGEMENT}>
              <CollaboratorAllocationFormPage />
            </RoleBasedRoute>
          }
        />
      </Route>

      {/* Redirect padrão */}
      <Route path="/" element={<Navigate to="directory" replace />} />
    </Routes>
  );
}
